import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import { LoadSiteSummariesSuccessAction, siteSummariesActionTypes} from '../actions/site-summaries';
import {SiteSummary} from '../models/shipping';

export interface SiteSummariesState {
  siteSummaries: SiteSummary;
}

const initialState: SiteSummariesState = {
  siteSummaries: undefined
};

export function SiteSummariesReducer(state: SiteSummariesState = initialState, action: Action): SiteSummariesState {
  switch (action.type) {
    case siteSummariesActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case siteSummariesActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case siteSummariesActionTypes.CLEAR:
      return handleLoadClearActions();
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: SiteSummariesState, action: LoadSiteSummariesSuccessAction): SiteSummariesState {
  const newState: SiteSummariesState = {
    siteSummaries: action.payload
  };
  return newState;
}

function handleLoadClearActions(): SiteSummariesState {
  const newState: SiteSummariesState = {
    siteSummaries: undefined
  };
  return newState;
}

function handleLoadErrorActions(state: SiteSummariesState): SiteSummariesState {
  return state;
}

export const siteSummariesdSelectors = {
  siteSummaries: (state: SiteSummariesState) => _.get(state, 'siteSummaries')
};
